<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label for="form-pass-cause" class="control-label">{{ inputLabel }}</label>
    <input
      v-model="inputValue"
      :disabled="disabled"
      type="time"
      class="form-control time-picker-input"
    />
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import passSectionMixin from '../../../../mixins/application-form/passSectionMixin'
import passInputMixin from '../../../../mixins/application-form/passInputMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'TimeOfInput',

  components: { Hint },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    passSectionMixin,
    passInputMixin
  ],

  props: {
    inputLabel: {
      default: 'Время начала'
    },

    inputHint: {
      default: undefined
    }
  }
}
</script>
